import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4926cc32&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4926cc32')) {
      api.createRecord('4926cc32', component.options)
    } else {
      api.reload('4926cc32', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=4926cc32&", function () {
      api.rerender('4926cc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Header.vue"
export default component.exports